import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FoyTvRoutingModule } from './foy-tv-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FoyTvRoutingModule
  ]
})
export class FoyTvModule { }

/**
 * Modal for Tv-Channel list Response
 */
export class MtvChannelResponse {
  token!: string;
  statusCode!: number;
  message!: string;
  data: any = [MtvChannelResponseData];
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Tv-Channel data 
 */
export class MtvChannelResponseData {
  id!: any;
  title!: string;
  thumbnail!: string;
  url!: string;
  description!: string;
  category!: string;
  category_id!: string;
  is_active!: boolean;
  is_show_on_blog!: string;
  skip!: string;
  take!: string;
  showImage: boolean = false;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

